module.exports = __webpack_public_path__ + "static/covid-19-6-5508af223ad4de035aad3731e18e9356.jpg";